/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ZoneService} from "../services/zone.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { Zone } from "app/models/zone";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class ZonesPagingResolver implements Resolve<PagedResults<Zone>> {

  constructor(
    private mZoneService: ZoneService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Zone>> {
    try {
      return await this.mZoneService.getAllZonesForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Zones... Error: " + error, error);
    }
  }

}
